import { Grid2, styled } from '@mui/material';
import { AppTypography } from '../../AppTypography/AppTypography';

const StyledAppTypography = styled(AppTypography)({
	textWrap: 'balance',
});

export const BulletList = ({ items }: { items: string[] }) => (
	<Grid2 ml={3} my={1}>
		<ul>
			{items.map((item, idx) => (
				<li key={idx}>
					<StyledAppTypography text={item} element='body2' textAlign='left' />
				</li>
			))}
		</ul>
	</Grid2>
);
